import { render } from "./Workshop.vue?vue&type=template&id=2dba790a"
import script from "./Workshop.vue?vue&type=script&lang=js"
export * from "./Workshop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/buildings/Workshop.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2dba790a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2dba790a', __exports__)) {
    api.reload('2dba790a', __exports__)
  }
  
  module.hot.accept("./Workshop.vue?vue&type=template&id=2dba790a", () => {
    api.rerender('2dba790a', render)
  })

}


export default __exports__